/* eslint-disable */

//tslint:disable

import { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api/shared/http';
import {
  TAddAnalyticsOrderModel,
  IAddAnalyticsOrderRequest,
  IMappers,
  IAddAnalyticsOrderResponse,
  IAddAnalyticsOrderResponseError,
  TAddAnalyticsOrderResponse,
} from './types';

const defaultConfig: TAddAnalyticsOrderModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  method: 'POST',
  microserviceName: 'valuation-b2b',
  pathApi: '/v1/add-analytics-order/',
  hostType: 'ud-api',
} as TAddAnalyticsOrderModel;

function createAddAnalyticsOrderModel(parameters: IAddAnalyticsOrderRequest): TAddAnalyticsOrderModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IAddAnalyticsOrderOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  parameters: IAddAnalyticsOrderRequest;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
}

async function fetchAddAnalyticsOrder<TResponse200, TResponse400>({
  httpApi,
  parameters,
  config,
  mappers,
}: IAddAnalyticsOrderOptions<TResponse200, TResponse400>): Promise<
  TResponse200 | TResponse400 | TAddAnalyticsOrderResponse
> {
  const { response, statusCode } = await httpApi.fetch(createAddAnalyticsOrderModel(parameters), config);

  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IAddAnalyticsOrderResponse);
    }

    if (statusCode === 400) {
      return mappers[400](response as IAddAnalyticsOrderResponseError);
    }
  }

  return { response, statusCode } as TAddAnalyticsOrderResponse;
}

export { defaultConfig, createAddAnalyticsOrderModel, fetchAddAnalyticsOrder };
